import { render, staticRenderFns } from "./SfAccordion.vue?vue&type=template&id=13daa172&"
import script from "./SfAccordion.vue?vue&type=script&lang=js&"
export * from "./SfAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SfAccordion.vue?vue&type=style&index=0&id=13daa172&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports